import type { Condition } from '../../../../../../../common/types';

export const filterConditionsList = (
	conditions: Condition[],
	newConditions: Condition[],
): Condition[] =>
	conditions.filter(
		(condition) =>
			!newConditions.find(
				(selectedCondition) => selectedCondition.conditionId === condition.conditionId,
			),
	);
